import { useFormik } from "formik";
import { useContext, useState } from "react";

import { offer_id, offer_name, tag_id, tag_name } from "../../../../constants";
import { mapStates } from "../../../../constants/mapRegions";
import { Context } from "../../../../context/context";
import LeadService from "../../../../services/leadService";
import { validLeadConvert } from "../../../../services/leadValidation";
import sessionTracking from "../../../../services/sessionTracking";
import { userQlFlow } from "../../../../services/userQLFlow";
import { sendAnalytics } from "../../../../utils/analyticsCommon";
import { getCookie } from "../../../../utils/cookie";

const useBookingForm = () => {
  const state = useContext(Context);
  const { showSnackbar, updateUserQlData, showReviewStoryDrawer } =
    useContext(Context);
  const [loading, setLoading] = useState(false);
  const [vehicleDetails, setVehicleDetails] = useState({});
  let cacheInfo = getCookie("user_verified")
    ? JSON.parse(getCookie("user_verified"))
    : "";

  const form = useFormik({
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: {
      name: cacheInfo?.name ?? "",
      mobile: cacheInfo?.phone ?? "",
      vehicle: "none",
      state: "none",
    },

    validate: (values) => {
      const errors = { ...values?.errors };

      if (!values?.mobile?.toString()) {
        errors.mobile = "Mobile Number is Mandatory";
      }
      if (values?.mobile?.toString()?.length !== 10) {
        errors.mobile = "Enter a valid 10 digit Mobile Number";
      }
      if (values?.mobile && values?.mobile[0] < 5) {
        errors.mobile = "Enter Valid Mobile Number";
      }
      // if (cacheInfo?.verified === false) {
      //   errors.mobile = "Validate your Mobile Number";
      // }
      if (values?.vehicle === "none") {
        errors.vehicle = "Select vehicle to purchase";
      }
      if (values?.state === "none" || values.state?.length === 0) {
        errors.state = "Select a state to proceed";
      }

      // if (
      //   state.posthogValues === "otpVerificationVar" &&
      //   state?.isOTPValidated &&
      //   (cacheInfo?.verified === undefined || cacheInfo?.verified === false) &&
      //   values?.mobile?.toString().length === 10
      // ) {
      //   errors.mobile = "Verify your Mobile Number with OTP";
      // }
      if (state?.showOtpModule) {
        if (!values?.otp?.toString()) {
          errors.otp = "Otp Number is Mandatory";
        }
        if (values?.otp?.toString()?.length !== 6) {
          errors.otp = "Enter Valid Otp";
        }
      }

      const ipInformation = localStorage.getItem("geoLocation")
        ? JSON.parse(localStorage.getItem("geoLocation"))
        : {};

      if (values?.mobile?.toString()?.length === 10) {
        let payload = {
          phoneNumber: values?.mobile,
          connectType: "Booking page",
          type: "new_form",
          cityInfo: ipInformation?.city,
          geoInfo: ipInformation,
        };
        sendAnalytics("v2_lead_form_entered_mobile", payload, "en");

        const leadPayload = {
          name: "",
          phone: values?.mobile,
          state: mapStates[ipInformation?.countryRegion] ?? "Others",
          leadIntent: "HIGH_INTENT",
          subSource: "Booking page",
        };

        // param: leadpayload, analyticsPayload
        validLeadConvert(leadPayload, payload);
      }
      return errors;
    },

    onSubmit: (values) => {
      let analytics_payload = {
        vehicle_name: vehicleDetails?.name ?? "",
        vehicle_id: vehicleDetails?.vehicle_id ?? "",
        emi_shown: vehicleDetails?.emiPrice ?? "",
        price_shown: vehicleDetails?.price ?? "",
        offer_name: offer_name,
        offer_id: offer_id,
        tag_name: tag_name,
        tag_id: tag_id,
        user_name: values.name,
        phone_number: values?.mobile,
        state: state?.selectedState,
        button_trigger_location: "booking form 499",
        type: "new_form",
        is_otp_verified: state?.leadVerifiedStatus,
      };
      sendAnalytics("reserve_vehicle_button_clicked", analytics_payload, "en");
      let payload = {
        name: values?.name ?? "",
        phone: values.mobile,
        pan: "",
        pincode: "",
        dob: "",
        state: values?.state ?? "Unknown",
        optedExchange: "",
        vehicleSelected: values.vehicle,
        language: "en",
        refNumber: "",
        leadIntent: "HIGH_INTENT",
        subSource: "Booking page",
        verified: state?.leadVerifiedStatus,
      };

      setLoading(true);

      LeadService(payload)
        .then((response) => {
          let bookingInfo = {
            leadUuid: response?.data?.uuid,
            vehicleUuid: vehicleDetails?.uuid,
          };

          const sessionInfo = {
            leadUuid: response?.data?.uuid,
            newSession: true,
            formSubmitted: true,
            leadIntent: "HIGH_INTENT",
          };

          sessionTracking(sessionInfo);

          setLoading(false);

          showSnackbar("We will get back to you soon!!", "success");

          // Enable QL Lead flow
          userQlFlow(state, updateUserQlData, showReviewStoryDrawer);

          // PaymentService(bookingInfo)
          //   .then((response) => {
          //     localStorage.setItem(
          //       "formData",
          //       JSON.stringify({
          //         name: values?.name,
          //         phone: values?.mobile,
          //         state: values?.state,
          //         bookingId: response?.data?.vehicleBooking?.uuid,
          //         vehicle: vehicleDetails?.brand,
          //       })
          //     );

          //     if (response?.data?.paymentSessionId) {
          //       const Cashfree = window.Cashfree;
          //       const sessionId = response?.data?.paymentSessionId;
          //       const cf = new Cashfree(sessionId);
          //       cf.redirect();

          //       // window.open(response?.data?.paymentLink, "_self");
          //       showSnackbar(
          //         "Let's pay and get the vehicle in just 5 days",
          //         "success"
          //       );
          //     } else {
          //       showSnackbar("Oops, Something went wrong Try Again!!", "error");
          //     }
          //     setLoading(false);
          //   })
          //   .catch((error) => {
          //     showSnackbar(
          //       "Oops, something went wrong. Please try again later.",
          //       "error"
          //     );
          //   });
        })
        .catch((error) => {
          showSnackbar(
            "Oops, something went wrong. Please try again later.",
            "error"
          );
        });
    },
  });
  return {
    form,
    loading,
    setVehicleDetails,
  };
};

export default useBookingForm;
